// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../ASSETS/LOGO/homebg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_modalContent__FJo9p {
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  animation: modal_backdropFadeIn__y\\+-ZM 0.5s forwards;
}

.modal_modalBody__sq0Tk {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}

.modal_modalImage__QcpFu {
  min-width: 650px;
  height: 100%;
  object-fit: cover;
  clip-path: ellipse(100% 60% at 0% 50%);
  animation: modal_zoomInAndMove__1SIpD 1s forwards 0.2s;
  opacity: 0;
  visibility: hidden;
}

.modal_modalText__8oBW1 {
  width: 160%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transform: translateX(100%);
  animation: modal_textSlideIn__Oaz\\+1 0.5s forwards 1s, modal_modalContentSlideIn__WJ94- 1s forwards 0.5s;
  color: #98adb0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.modal_modalTextContent__TmIwb {
  width: 80%;
  text-align: left;
}

.modal_modalBtnSection__ID6jv {
  display: flex;
  gap: 20px;
  justify-content: space-evenly;
  margin-top: 50px;
}

.modal_modalBtn__Q6Jmg {
  color: #98adb0;
  background: transparent;
  box-shadow: none;
  border: 2px solid #98adb0;
  border-radius: 20px;
  width: 200px;
  font-weight: bold;
  padding: 10px;
}

.modal_modalContent__FJo9p.modal_closing__oIhVx {
  animation: modal_modalContentFadeOut__0Z7Ti 0.5s forwards;
}

.modal_modalText__8oBW1.modal_closing__oIhVx {
  animation: modal_textFadeOut__1Wl8p 1s forwards;
}

.modal_modalBackdrop__\\+Bu0A.modal_closing__oIhVx {
  animation: modal_backdropFadeOut__Ij10E 0.5s forwards;
}
.modal_modalTitleContent__05ZHY {
  display: flex;
}
.modal_modalTitleContent__05ZHY h2 {
  font-size: 1.5rem;
}
.modal_logo__NLe6p {
  width: 2rem;
  height: 2rem;
  margin-left: 1em;
  /* height: 80px; */
}

@media (max-width: 1024px) {
  .modal_modalBackdrop__\\+Bu0A {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    padding: 0;
    opacity: 0;
    animation: modal_backdropFadeIn__y\\+-ZM 0.5s forwards;
  }

  .modal_modalContent__FJo9p {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    padding: 0;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    opacity: 0;
    animation: modal_modalContentSlideIn__WJ94- 1s forwards 0.5s;
    width: 100%;
    height: 100%;
    overflow: scroll;
    border-radius: 10px;
  }

  .modal_modalBody__sq0Tk {
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .modal_modalImage__QcpFu {
    width: 100%;
    height: 50%;
    object-fit: cover;
    clip-path: ellipse(100% 80% at 50% 0%);
    animation: modal_zoomInAndMove__1SIpD 1s forwards 0.2s;
  }

  .modal_modalText__8oBW1 {
    width: 100%;
    height: 50%;
    opacity: 0;
    visibility: hidden;
    transform: translateY(30px);
    animation: modal_textSlideInMobile__A0wez 0.5s forwards 1s;
    color: #98adb0;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0 15px;
    opacity: 0;
    visibility: hidden;
  }

  .modal_modalBtnSection__ID6jv {
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: center;
    margin-top: 10px;
  }

  .modal_modalBtn__Q6Jmg {
    color: #98adb0;
    background: transparent;
    box-shadow: none;
    border: 2px solid #98adb0;
    border-radius: 20px;
    width: 150px;
    font-weight: bold;
    padding: 8px;
  }

  .modal_modalBtn__Q6Jmg:hover {
    color: #333;
    background-color: #ffe600;
    border: 2px solid #98adb0;
    transition: 0.5s;
  }
  .modal_logo__NLe6p {
    display: none;
  }
}

@keyframes modal_backdropFadeIn__y\\+-ZM {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}

@keyframes modal_backdropFadeOut__Ij10E {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes modal_zoomInAndMove__1SIpD {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
    visibility: visible;
  }
}

@keyframes modal_textSlideIn__Oaz\\+1 {
  from {
    opacity: 0;
    transform: translateX(100px);
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
}

@keyframes modal_modalContentSlideIn__WJ94- {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
}

@keyframes modal_textFadeOut__1Wl8p {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes modal_modalContentFadeOut__0Z7Ti {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes modal_textSlideInMobile__A0wez {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/MODAL/modal.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,yDAAqD;EACrD,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,qDAAuC;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,sDAAyC;EACzC,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,wGAA6E;EAC7E,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yDAA4C;AAC9C;;AAEA;EACE,+CAAkC;AACpC;;AAEA;EACE,qDAAwC;AAC1C;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,qDAAuC;EACzC;;EAEA;IACE,yDAAqD;IACrD,4BAA4B;IAC5B,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,4DAA+C;IAC/C,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,sDAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,0DAA6C;IAC7C,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;EAC1B;AACF","sourcesContent":[".modalContent {\n  width: 100%;\n  height: 100%;\n  background-image: url(\"../../ASSETS/LOGO/homebg.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  animation: backdropFadeIn 0.5s forwards;\n}\n\n.modalBody {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modalImage {\n  min-width: 650px;\n  height: 100%;\n  object-fit: cover;\n  clip-path: ellipse(100% 60% at 0% 50%);\n  animation: zoomInAndMove 1s forwards 0.2s;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.modalText {\n  width: 160%;\n  height: 100%;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateX(100%);\n  animation: textSlideIn 0.5s forwards 1s, modalContentSlideIn 1s forwards 0.5s;\n  color: #98adb0;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.modalTextContent {\n  width: 80%;\n  text-align: left;\n}\n\n.modalBtnSection {\n  display: flex;\n  gap: 20px;\n  justify-content: space-evenly;\n  margin-top: 50px;\n}\n\n.modalBtn {\n  color: #98adb0;\n  background: transparent;\n  box-shadow: none;\n  border: 2px solid #98adb0;\n  border-radius: 20px;\n  width: 200px;\n  font-weight: bold;\n  padding: 10px;\n}\n\n.modalContent.closing {\n  animation: modalContentFadeOut 0.5s forwards;\n}\n\n.modalText.closing {\n  animation: textFadeOut 1s forwards;\n}\n\n.modalBackdrop.closing {\n  animation: backdropFadeOut 0.5s forwards;\n}\n.modalTitleContent {\n  display: flex;\n}\n.modalTitleContent h2 {\n  font-size: 1.5rem;\n}\n.logo {\n  width: 2rem;\n  height: 2rem;\n  margin-left: 1em;\n  /* height: 80px; */\n}\n\n@media (max-width: 1024px) {\n  .modalBackdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999;\n    padding: 0;\n    opacity: 0;\n    animation: backdropFadeIn 0.5s forwards;\n  }\n\n  .modalContent {\n    background-image: url(\"../../ASSETS/LOGO/homebg.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding: 0;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    opacity: 0;\n    animation: modalContentSlideIn 1s forwards 0.5s;\n    width: 100%;\n    height: 100%;\n    overflow: scroll;\n    border-radius: 10px;\n  }\n\n  .modalBody {\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .modalImage {\n    width: 100%;\n    height: 50%;\n    object-fit: cover;\n    clip-path: ellipse(100% 80% at 50% 0%);\n    animation: zoomInAndMove 1s forwards 0.2s;\n  }\n\n  .modalText {\n    width: 100%;\n    height: 50%;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(30px);\n    animation: textSlideInMobile 0.5s forwards 1s;\n    color: #98adb0;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: 0 15px;\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  .modalBtnSection {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    justify-content: center;\n    margin-top: 10px;\n  }\n\n  .modalBtn {\n    color: #98adb0;\n    background: transparent;\n    box-shadow: none;\n    border: 2px solid #98adb0;\n    border-radius: 20px;\n    width: 150px;\n    font-weight: bold;\n    padding: 8px;\n  }\n\n  .modalBtn:hover {\n    color: #333;\n    background-color: #ffe600;\n    border: 2px solid #98adb0;\n    transition: 0.5s;\n  }\n  .logo {\n    display: none;\n  }\n}\n\n@keyframes backdropFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@keyframes backdropFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes zoomInAndMove {\n  from {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@keyframes textSlideIn {\n  from {\n    opacity: 0;\n    transform: translateX(100px);\n    visibility: hidden;\n  }\n  to {\n    opacity: 1;\n    visibility: visible;\n    transform: translateX(0);\n  }\n}\n\n@keyframes modalContentSlideIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@keyframes textFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes modalContentFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes textSlideInMobile {\n  from {\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `modal_modalContent__FJo9p`,
	"backdropFadeIn": `modal_backdropFadeIn__y+-ZM`,
	"modalBody": `modal_modalBody__sq0Tk`,
	"modalImage": `modal_modalImage__QcpFu`,
	"zoomInAndMove": `modal_zoomInAndMove__1SIpD`,
	"modalText": `modal_modalText__8oBW1`,
	"textSlideIn": `modal_textSlideIn__Oaz+1`,
	"modalContentSlideIn": `modal_modalContentSlideIn__WJ94-`,
	"modalTextContent": `modal_modalTextContent__TmIwb`,
	"modalBtnSection": `modal_modalBtnSection__ID6jv`,
	"modalBtn": `modal_modalBtn__Q6Jmg`,
	"closing": `modal_closing__oIhVx`,
	"modalContentFadeOut": `modal_modalContentFadeOut__0Z7Ti`,
	"textFadeOut": `modal_textFadeOut__1Wl8p`,
	"modalBackdrop": `modal_modalBackdrop__+Bu0A`,
	"backdropFadeOut": `modal_backdropFadeOut__Ij10E`,
	"modalTitleContent": `modal_modalTitleContent__05ZHY`,
	"logo": `modal_logo__NLe6p`,
	"textSlideInMobile": `modal_textSlideInMobile__A0wez`
};
export default ___CSS_LOADER_EXPORT___;
